module.exports = __webpack_public_path__ + "static/media/berkshirelogo.61fcc83c.svg";